export enum EnvironmentId {
  Production = "production",
  Test = "Testing",
  Development = "Development",
}
